import { render, staticRenderFns } from "./member-select.vue?vue&type=template&id=496e54f6&scoped=true"
import script from "./member-select.vue?vue&type=script&lang=js"
export * from "./member-select.vue?vue&type=script&lang=js"
import style0 from "./member-select.vue?vue&type=style&index=0&id=496e54f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e54f6",
  null
  
)

export default component.exports